import { cn } from "@/domains/library"

export interface MinMaxFilterViewProps {
  label: string
  value: number
  onChange: (value: number) => void
  mode: "min" | "max"
  onToggleMode: () => void
  className?: string
}

export const MinMaxFilterView = ({ label, value, onChange, mode, onToggleMode, className }: MinMaxFilterViewProps) => {
  return (
    <div
      className={cn(
        "group flex h-10 items-center overflow-hidden rounded-xl border border-p400-light bg-p400 shadow-sm ring-0 transition-all focus-within:border-primary-400/50 focus-within:ring-2 focus-within:ring-primary-400/20 hover:border-p300-light",
        className,
      )}
    >
      <div
        className="flex flex-1 cursor-text items-center pl-3 pr-1"
        onClick={(e) => {
          const input = e.currentTarget.querySelector("input")
          if (input) {
            input.focus()
          }
        }}
      >
        <span className="mr-[12px] select-none text-xs font-bold uppercase text-t200">{label}</span>
        <input
          type="number"
          min="0"
          step="any"
          value={value === 0 ? "" : value}
          onChange={(e) => {
            const numValue = parseFloat(e.target.value) || 0
            const clampedValue = Math.max(0, numValue)
            onChange(clampedValue)
          }}
          placeholder="0"
          className="h-full w-full border-none bg-transparent p-0 text-sm font-bold text-t100 outline-none [-moz-appearance:textfield]  placeholder:text-t300 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
        />
      </div>
      <button
        onClick={onToggleMode}
        className="flex h-full min-w-[42px] cursor-pointer items-center justify-center border-l border-p400-light bg-p500/50 px-3 text-[10px] font-bold uppercase tracking-wider text-t300 transition-colors hover:bg-primary-400/10 hover:text-primary-400"
      >
        {mode}
      </button>
    </div>
  )
}
